export default __webpack_public_path__ + "static/media/hammer-mockup-mobile.6443447f.png";